import { render, staticRenderFns } from "./LitterFeeTable.vue?vue&type=template&id=3ae7a51c"
import script from "./LitterFeeTable.vue?vue&type=script&lang=ts"
export * from "./LitterFeeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports